import React, { useState } from 'react';
import './Trips.css';

function Trips() {
  const [trips] = useState([
    {
      id: 1,
      title: 'Cozy Apartment in SF',
      location: 'San Francisco, CA',
      checkIn: '2026-03-15',
      checkOut: '2026-03-22',
      status: 'confirmed',
      photo: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=500'
    },
    {
      id: 2,
      title: 'Modern Condo in NYC',
      location: 'New York, NY',
      checkIn: '2026-04-01',
      checkOut: '2026-04-08',
      status: 'pending',
      photo: 'https://images.unsplash.com/photo-1545324418-cc1a9f6bb8b1?w=500'
    }
  ]);

  const getStatusColor = (status) => {
    return status === 'confirmed' ? '#4CAF50' : '#FFA500';
  };

  return (
    <div className="trips-container">
      <div className="trips-header">
        <h1>✈️ My Trips</h1>
        <p>{trips.length} upcoming stays</p>
      </div>

      {trips.length === 0 ? (
        <div className="empty-state">
          <p>No trips booked yet. Start your search to book a stay!</p>
          <button className="browse-btn">Browse Listings</button>
        </div>
      ) : (
        <div className="trips-list">
          {trips.map(trip => (
            <div key={trip.id} className="trip-card">
              <div className="trip-image">
                <img src={trip.photo} alt={trip.title} />
              </div>
              <div className="trip-details">
                <div className="trip-header">
                  <div>
                    <h3>{trip.title}</h3>
                    <p className="location">{trip.location}</p>
                  </div>
                  <span className="status-badge" style={{ backgroundColor: getStatusColor(trip.status) }}>
                    {trip.status.charAt(0).toUpperCase() + trip.status.slice(1)}
                  </span>
                </div>
                
                <div className="trip-dates">
                  <div className="date-item">
                    <span className="label">Check-in</span>
                    <span className="date">{new Date(trip.checkIn).toLocaleDateString()}</span>
                  </div>
                  <div className="date-item">
                    <span className="label">Check-out</span>
                    <span className="date">{new Date(trip.checkOut).toLocaleDateString()}</span>
                  </div>
                  <div className="date-item">
                    <span className="label">Duration</span>
                    <span className="date">
                      {Math.ceil((new Date(trip.checkOut) - new Date(trip.checkIn)) / (1000 * 60 * 60 * 24))} nights
                    </span>
                  </div>
                </div>

                <div className="trip-actions">
                  <button className="message-btn">📧 Message Host</button>
                  <button className="details-btn">View Details</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Trips;
